import * as React from 'react';
import * as moment from 'moment';

import { SpinnerPage } from '@common/components';
import { MultiEmailInput } from '@common/components/multi-email-input';
import { ContractDetailsViewModel } from '@models/Contract';

import * as classes from './contract-payment-confirmation.scss';

export interface ContractPaymentConfirmationComponentProperties {
  readonly contract?: ContractDetailsViewModel;
  readonly isTransactionCompletionScreen: boolean;
  readonly contractId: number;
  readonly paymentDate?: Date;
  readonly creditCardLastFour?: string;
  readonly emailAddresses: string[];
  readonly refundAmount?: number;
  readonly buttonRef?: (button: HTMLButtonElement) => void;
  readonly getContract: (contractId: number) => void;
  readonly setEmailAddresses: (emailAddresses: string[]) => void;
  readonly openCardSaveModal: () => void;
  readonly submit: (
    contractId: number,
    emailAddresses: string[],
    paymentDate: Date,
    creditCardLastFour?: string
  ) => void;
}

export class ContractPaymentConfirmationComponent extends React.Component<
  ContractPaymentConfirmationComponentProperties
> {
  buttonRef: (button: HTMLButtonElement) => void;
  public componentDidMount(): void {
    this.props.getContract(this.props.contractId);
  }

  public render(): JSX.Element {
    if (!this.props.contract) {
      return <SpinnerPage />;
    }

    let isRenewal: boolean = false;
    if (this.props.refundAmount) {
      isRenewal = true;
    }

    return (
      <>
        <div className="row top-xs center-xs">
          <div className="col-lg-9">
            {isRenewal && (
              <h2>
                The following amount will be refunded for this renewal contract #(
                {this.props.contract.contractNumber}
                ): ${this.props.refundAmount!}.
              </h2>
            )}
            <h2>
              Payment information has been submitted and a copy of contract #{this.props.contract.contractNumber} and
              its declarations has been emailed to the selected contacts.
            </h2>
            <div className={'text-left ' + classes.container}>
              <div className="row">
                <div className="form-control col-sm-4">
                  <label>Effective Date</label>
                  <h5>{moment(this.props.contract.termStart).format('MM/DD/YYYY')}</h5>
                </div>
                <div className="form-control col-sm-4">
                  <label>Expiration Date</label>
                  <h5>{moment(this.props.contract.termEnd).format('MM/DD/YYYY')}</h5>
                </div>
                <div className="form-control col-sm-4">
                  <label>Payment Date</label>
                  <h5>{moment(this.props.paymentDate).format('MM/DD/YYYY')}</h5>
                </div>
              </div>
              <div className="row">
                <div className="form-control col-sm-4">
                  <label>Total Cost</label>
                  <h5>
                    {this.props.contract && this.props.contract.ctcPriceAmount
                      ? '$' + this.props.contract.ctcPriceAmount.toFixed(2)
                      : 'N/A'}
                  </h5>
                </div>
                <div className="form-control col-sm-4">
                  <div className="col-sm-4">
                    <label>Credit Card</label>
                    <h5>{this.props.creditCardLastFour || '—'}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 dark-gray-bc p-10">
            <h2>Actions</h2>
            <a href={'/contract?clone=' + this.props.contractId} rel="noopener noreferrer" target="_blank">
              <button type="button" className="btn btn-primary">
                <i className="far fa-clone" /> Clone Contract
              </button>
            </a>
            {this.props.creditCardLastFour &&
              this.props.isTransactionCompletionScreen && (
                <button className="btn btn-primary" onClick={this.props.openCardSaveModal}>
                  <i className="far fa-credit-card" /> Save Card
                </button>
              )}
          </div>
        </div>

        <div className="row center-xs">
          <div className="col-xs-8">
            <div className="text-left">
              <label className="text-left">Email receipt:</label>
            </div>
            <MultiEmailInput onChange={(emails: string[]) => this.props.setEmailAddresses(emails)} />
          </div>
          {this.renderButton()}
        </div>
      </>
    );
  }

  private renderButton(): JSX.Element {
    if (this.props.buttonRef) {
      return (
        <button
          hidden={true}
          onClick={() =>
            this.props.submit(
              this.props.contractId,
              this.props.emailAddresses,
              moment(this.props.paymentDate).toDate(),
              this.props.creditCardLastFour
            )
          }
          ref={this.props.buttonRef}
        >
          Test
        </button>
      );
    } else {
      return (
        <div>
          <br />
          <button
            className="btn btn-primary"
            onClick={() =>
              this.props.submit(
                this.props.contractId,
                this.props.emailAddresses,
                moment(this.props.paymentDate).toDate(),
                this.props.creditCardLastFour
              )
            }
          >
            Send
          </button>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-payment/_components/confirmation/_components/contract-payment-confirmation.component.tsx